import { Paperclip, X } from 'lucide-react';

import { Button } from '@/components/ui/Button';

function formatFileSize(sizeInBytes: number) {
  if (sizeInBytes < 1024) {
    return `${sizeInBytes} B`;
  }

  if (sizeInBytes < 1024 * 1024) {
    return `${(sizeInBytes / 1024).toFixed(1)} KB`;
  }

  return `${(sizeInBytes / (1024 * 1024)).toFixed(2)} MB`;
}

interface SelectedFilesListProps {
  files: File[];
  disabled: boolean;
  onRemove: (index: number) => void;
}

export function SelectedFilesList({
  files,
  disabled,
  onRemove,
}: SelectedFilesListProps) {
  if (files.length === 0) {
    return null;
  }

  return (
    <ul className="space-y-2">
      {files.map((file, index) => (
        <li
          key={`${file.name}-${file.lastModified}`}
          className="flex items-center justify-between rounded-md border bg-gray-50 px-3 py-2"
        >
          <div className="flex items-center gap-2">
            <Paperclip className="h-4 w-4 text-gray-500" />
            <p className="text-sm text-gray-700">
              {file.name} ({formatFileSize(file.size)})
            </p>
          </div>

          <Button
            type="button"
            size="icon"
            variant="ghost"
            disabled={disabled}
            onClick={() => onRemove(index)}
          >
            <X className="h-4 w-4" />
          </Button>
        </li>
      ))}
    </ul>
  );
}
